import { ButtonItem } from '../text-buttons/TextButtons.styles';
import { StyledColorItem } from './Colors.styles';
import { ColorSource } from './colorSource';

export const ColorItem = ({
  source,
  active,
  colorName,
  color,
  imageUrl,
  onClick,
}: {
  source: ColorSource;
  active: boolean;
  colorName: string;
  color?: string;
  imageUrl?: string;
  onClick: () => void;
}) => {
  return (
    <>
      {source === 'css' && <StyledColorItem active={active} color={color} onClick={onClick} />}

      {source === 'image' && <StyledColorItem active={active} image={imageUrl} onClick={onClick} />}

      {source === 'fallback' && (
        <ButtonItem active={active} onClick={onClick}>
          {colorName}
        </ButtonItem>
      )}
    </>
  );
};
